var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMbriLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5c-.276 0-.5.224-.5.5v11c0 .652 1 .67 1 0V6h14v10.5c0 .672 1 .656 1 0v-11c0-.276-.224-.5-.5-.5zm-1-2C2.678 3 2 3.678 2 4.5v12c0 .67 1.01.66 1 0v-12c0-.286.214-.5.5-.5h17c.286 0 .5.214.5.5v12c0 .668 1 .656 1 0v-12c0-.822-.678-1.5-1.5-1.5zm-3 15c-.276 0-.5.224-.5.5C0 19.876 1.124 21 2.5 21h19c1.376 0 2.5-1.124 2.5-2.5 0-.276-.224-.5-.5-.5zm.705 1h21.59c-.217.558-.653 1-1.295 1h-19c-.642 0-1.078-.442-1.295-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbriLaptop);
export default __webpack_public_path__ + "static/media/mbri-laptop.c91390cda94585f16af77b195828a876.svg";
export { ForwardRef as ReactComponent };